import React from "react";
import { TextProps } from "@common/types";
import { cn } from "@app/lib/utils";

const variants = {
  default: "text-sm leading-5 text-foreground",
  gray: "text-sm leading-5 text-muted-foreground",
  muted: "text-sm leading-5 text-muted-foreground",
  disabled: "text-sm leading-5 text-muted-foreground opacity-70",
  primary: "text-sm leading-5 text-primary",
  success: "text-sm leading-5 text-success",
  danger: "text-sm leading-5 text-destructive",
  warning: "text-sm leading-5 text-warning",
  info: "text-sm leading-5 text-info",
  light: "text-sm leading-5 text-foreground",
  dark: "text-sm leading-5 text-foreground",
};

export const Text = React.forwardRef(function Text(
  {
    variant,
    block,
    icon,
    children,
    className,
    iconPosition = "start",
    padding,
    ...rest
  }: TextProps &
    (
      | React.HTMLAttributes<HTMLDivElement>
      | React.HTMLAttributes<HTMLParagraphElement>
    ),
  ref,
) {
  const Component: any = block ? "div" : "span";
  return (
    <Component
      className={cn(
        variants[variant || "default"],
        padding === "large"
          ? "px-3 py-3"
          : padding === "medium"
            ? "px-3 py-2"
            : padding === "small" && "px-3 py-1.5",
        className,
      )}
      ref={ref}
      {...rest}
    >
      {icon ? (
        <div className="flex items-center gap-1.5">
          {iconPosition === "start" && icon}
          <div>{children}</div>
          {iconPosition === "end" && icon}
        </div>
      ) : (
        children
      )}
    </Component>
  );
});
